module.exports = __webpack_public_path__ + "static/media/5.4ee473d6.png";